"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.973 5.98 7.158 10.2h2.306c.753 0 1.237.724 1.056 1.398l-.628 2.334 2.975-4.867h-2.349c-.768 0-1.251-.752-1.045-1.432zm1.373-2.861a1.1 1.1 0 0 1 .557 1.315l-.977 3.23H13.4c.898 0 1.359.989.93 1.69l-4.351 7.12c-.33.538-.94.628-1.382.425a1.1 1.1 0 0 1-.604-1.3l1.075-4H6.6c-.919 0-1.373-1.027-.906-1.726L9.951 3.49c.35-.525.961-.59 1.395-.371",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TriggerIcon20.js.map